<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="公告标题" property="title">
									<el-input
										v-model="searchForm.title"
										placeholder="输入公告标题"
										clearable
										@keyup.enter.native="getNotices"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="pickerOptions"
											@change="getNotices"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="getNotices">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<!-- <el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="已发布" name="已发布"></el-tab-pane>
							<el-tab-pane label="草稿箱" name="草稿箱"></el-tab-pane>
						</el-tabs> -->
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button v-if="hasAuth('info:notice:save')"  type="primary" @click="addHandle">新增</el-button>
							<el-popconfirm style="margin-left: 5px" title="这是确定批量删除吗？" @confirm="delHandle(null)">
								<!-- <el-button type="danger" :disabled="delBtlStatu" v-if="hasAuth('sys:user:delete')">批量删除</el-button> -->
								<el-button v-if="hasAuth('info:notice:delete')" slot="reference" :disabled="delBtlStatu" type="danger" >批量删除</el-button>
							</el-popconfirm>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="50" align="center"></el-table-column>
						<el-table-column type="index" width="80" align="center" label="编号"></el-table-column>
						<el-table-column prop="title" label="公告标题" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="content" label="公告内容" show-overflow-tooltip align="center"></el-table-column> -->
						<el-table-column prop="publisher" label="发布人" sortable align="center"></el-table-column>
						<el-table-column prop="publishTime" label="发布时间" sortable align="center"></el-table-column>

						<el-table-column
						  label="状态"
						  align="center"
						  show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.statusFlag == 1 ? 'primary' : 'warning'"
								  disable-transitions>{{ scope.row.statusFlag == 1 ? '已发布' : '草稿' }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="viewHandle(scope.row.id)" title="查看公告详情">详情</el-button>
								<el-button type="text" style="color: orange" @click="editHandle(scope.row.id)" title="编辑公告内容">编辑</el-button>
								<template>
									<el-popconfirm style="margin-left: 10px" title="确定要删除该公告吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" style="color: red" slot="reference" title="删除公告">删除</el-button>
									</el-popconfirm>
								</template>
							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">

				<el-form-item label="标题" prop="title">
					<el-input v-model="editForm.title" placeholder="请输入标题" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="公告内容" prop="content">
					<!-- <el-input type="textarea" rows="5" v-model="editForm.content" placeholder="请输入内容" autocomplete="off"></el-input> -->
					<Editor v-model="editForm.content" :min-height="192"/>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">{{title=='新增公告' ? '发 布' : '确认修改'}}</el-button>
				<!-- <el-button type="warning" @click="submitForm('editForm')">存草稿</el-button> -->
			</div>
		</el-dialog>


		<!--查看详情-->
		<el-dialog
		  title=""
		  :visible.sync="dialogVisibleView"
		  width="700px"
		  :before-close="handleCloseView"
		  :close-on-click-modal="false">

			<div class="notice_view">
				<h2>{{editForm.title}}</h2>
				<div class="info">
					<span>发布人：{{editForm.publisher}}</span>
					<span>发布时间：{{editForm.publishTime}}</span>
				</div>
				<div class="content" v-html="editForm.content"></div>
				<!-- <div class="content">{{editForm.content}}</div> -->
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleCloseView">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Editor from '../components/Editor/index.vue'

import {getList, getListOnce, addNotice, updateNotice, delNotice} from '../../apis/notice.js'
export default {
	name: "Notice",	// 公告管理
	components: {
		Editor
	},
	data() {
		return {
			loading: true,

			activeName: '已发布',
			dateRange: [],
			dateRangeMoren: [],
			searchForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisibleView: false,
			dialogVisible: false,
			title: '新增公告',
			editForm: {},

			tableData: [],

			editFormRules: {
				title: [
					{required: true, message: '请填写公告标题', trigger: 'blur'}
				],
				content: [
					{required: true, message: '请填写公告内容', trigger: 'blur'}
				],
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		let t = new Date()
		let startDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-01'
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.dateRange = [startDate, endDate]
		this.dateRangeMoren = [startDate, endDate]
		this.getNotices()
	},
	methods: {
		resetSearchForm() {
			this.searchForm = {}
			this.getNotices()
		},
		handleClick() {
			console.log('切换状态');
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.getNotices()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getNotices()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		handleCloseView() {
			this.dialogVisibleView=false
		},
		getNotices() {
			getList({current: this.current, size: this.size, ...this.searchForm, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]}).then(res => res.data).then(res => {
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// console.log(this.editForm);
					if (this.editForm.id) {
						updateNotice(this.editForm).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							this.getNotices()
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					} else {
						// console.log(this.editForm);
						addNotice({...this.editForm}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							this.getNotices()
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		addHandle() {
			this.editForm = {}
			this.title = '新增公告'
			this.dialogVisible = true
		},
		viewHandle(id) {
			const loading = this.$loading({
				text: '加载中...',
			});
			getListOnce(id).then(res => res.data).then(res => {
				loading.close()
				this.editForm = res.data
				this.dialogVisibleView = true
			})
		},
		editHandle(id) {
			this.title = '编辑公告'
			getListOnce(id).then(res => res.data).then(res => {
				this.editForm = res.data
				this.dialogVisible = true
			})
		},
		delHandle(id) {
			var ids = []
			if (id) {
				ids.push(id)
			} else {
				this.multipleSelection.forEach(row => {
					ids.push(row.id)
				})
			}
			// console.log(ids);

			delNotice(ids).then(res => res.data).then(res => {
				this.$message({
					showClose: true,
					message: '操作成功',
					type: 'success',
					onClose: () => {
						this.multipleSelection = []
						this.delBtlStatu = true
					}
				});
				this.getNotices()
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}
.notice_view h2 {
	width: 100%;
	text-align: center;
	margin-top: 0px;
}
.notice_view .info {
	width: 100%;
	display: flex;
	justify-content: space-around;
	color: #989a9b;
	margin-bottom: 10px;
}
.notice_view .content {
	width: 100%;
	text-indent: 2em;
}

</style>